module.exports = __webpack_public_path__ + "static/media/job_mela.4a504caa.jpg";